<template>
  <div class="tabs-select-styleanimated fadeIn">
    <GeneralSpinner v-if="spinner_eve"></GeneralSpinner>
    <div class="page-card-margin row" v-else="">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <strong><i class="fa fa-bell-o"></i> {{web_texts.system_events}}</strong>
          </div>
          <div class="card-block">
            <vue-good-table :columns="columns" :rows="events" :paginate="true" :perPage="10"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import trans_cat from '../translates/cat/Events';
  import trans_es from '../translates/es/Events';
  import constants from '../constants'
  import middleware from '../utilities/middlewares'
  import GeneralSpinner from './partials/GeneralSpinner.vue';

  export default {
    name: '',
    data() {
      return {
        web_texts: {"system_events": "Esdeveniments interns del sistema"},
        system: '',
        events: [],
        spinner_eve: true,
        columns: [
          {
            label: 'Date',
            field: 'date',
            html: true
          },
          {
            label: 'Name',
            field: 'alias',
            html: true
          },
          {
            label: 'Anotation',
            field: 'annotation',
            html: true
          },
          {
            label: 'Value',
            field: 'value',
            html: true
          }
        ],
      }
    },
    mounted() {
      middleware.userIsLoged();
      window.localStorage.setItem('real_time_control', '["events","events"]');
      this.web_texts=middleware.selectTranslation(trans_cat,trans_es);

      this.system=JSON.parse(localStorage.getItem('system'));
      this.getEvents();
    },
    components:{
      GeneralSpinner
    },
    methods: {
      // Llegir tots els events
      getEvents () {
        axios.post(constants.ROOT_URL + '/api/v1/events', {
          system_id: this.system.id,
          client_device: 'd'
        }).then((response) => {
          this.events = response.data;
          this.spinner_eve=false;
        }, (response) => {
          console.log(response.data);
        });
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// Events.vue?997ba8f0